<template>

    <div class="page-content">
        <div class="container-fluid">

            <Breadcrumb
                :pgTitle="$t('nav.bills')"
                :pgIcon="'bx bx-wallet-alt'"
                :refs="refs"
                :addNew="addNew">
            </Breadcrumb>


            <DataTable
                :refs="refs"
                :colspan=6

                :hasHashId=true
                :hasMultiSelect=false
                :hasBulkAction=true
                :HasExport=true
                :hasShowEntries=true
                :hasFilterByDate="true"

                :fields="{
                    'id': 'id',
                    'date': 'date',
                    'title': 'title',
                }"

                :hasImage=false
                :image="$t('view.bill_image')"
                :image_style="'width:35px;height:35px;border-radius:50%'"

                :hasTitle=true
                :title="$t('view.bill_name')"
                
                :hasDate=true
                :hasStatus=true
                :hasActions=true

                :actionable=true
                :sorDataTable=true

                v-on:hasAddNewPermission="handlePermissoinChange">
            </DataTable>

        </div>
    </div>

</template>

<script>
export default {
    name: 'List',
    components: {
        Breadcrumb: () => import('@/components/Breadcrumb.vue'),
        DataTable: () => import('@/components/DataTable.vue')
    },
    data(){
        return {    
            //
            addNew: false,
            refs: 'bills',
        }
    },
    watch: {
        //
    },
    mounted() {
        //
    },
    created() {
        //
    },
    methods: {
        handlePermissoinChange(event) {
            this.addNew = event;
        },
    },
}
</script>
